module.exports = __webpack_public_path__ + "img/logo_gaussy.72c8f8b.svg";